class INTENT.widgets.AdvancedTracking

  @ATTR_NAME: "data-widget-advanced-tracking"

  @ATTR_CONTAINER: "#{@ATTR_NAME}-container"
  @ATTR_FIELD: "#{@ATTR_NAME}-field"
  @ATTR_FIELD_ADD: "#{@ATTR_FIELD}-add"
  @ATTR_FIELD_REMOVE: "#{@ATTR_FIELD}-remove"
  @ATTR_FIELD_TYPE: "#{@ATTR_FIELD}-type"

  @NODE_NAME: "advanced_tracking"

  constructor: (@el) ->
    @s = @.constructor

    @container = @el.find "[#{@s.ATTR_CONTAINER}]"
    field_add = @el.find "[#{@s.ATTR_FIELD_ADD}]"
    field_remove = @el.find "[#{@s.ATTR_FIELD_REMOVE}]"
    select_type = @el.find "[#{@s.ATTR_FIELD_TYPE}]"

    field_add.on 'click', (el) =>
      @add_field(el)

    field_remove.on 'click', (el) =>
      @remove_field(el)

    select_type.on 'change', (el) =>
      @change_input_type(el)

  add_field: (el) ->
    new_field = $(@get_field_template())
    @init_new_field(new_field)
    @container.append(new_field)

  remove_field: (el) ->
    $(el.target).parents("[#{@s.ATTR_FIELD}]").remove();

  init_new_field: (field) ->
    field_remove = field.find("[#{@s.ATTR_FIELD_REMOVE}]")
    select_type = field.find(".select2-init")

    field_remove.on 'click', (el) =>
      @remove_field(el)

    select_type.on 'change', (el) =>
      @change_input_type(el)

    select_type.select2({
      minimumResultsForSearch: -1
    })

  change_input_type: (el) ->
    element = $(el.target)
    field = element.parents("[#{@s.ATTR_FIELD}]")
    type = element.val()
    field.find("input").attr('name', "#{@s.NODE_NAME}[#{type}][]")

  get_field_template: () ->
    return """
      <tr data-widget-advanced-tracking-field>
          <td>
              <select class="form-control select2-init" data-widget-advanced-tracking-field-type>
                  <option selected value="start">start</option>
                  <option value="firstQuartile">1st quartile</option>
                  <option value="midpoint">midpoint</option>
                  <option value="thirdQuartile">3rd quartile</option>
                  <option value="complete">complete</option>
              </select>
          </td>
          <td>
              <input type="text" class="col-md-12 form-control" name="#{@s.NODE_NAME}[start][]" value="">
          </td>
          <td>
              <a href="javascript:void(0)" data-widget-advanced-tracking-field-remove>
                  <i class="glyphicon glyphicon-remove"></i>
              </a>
          </td>
      </tr>
    """
